/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LicenseFeatureRequest
 */
export interface LicenseFeatureRequest {
    /**
     * 
     * @type {string}
     * @memberof LicenseFeatureRequest
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof LicenseFeatureRequest
     */
    expiresAtSeconds?: number;
}

/**
 * Check if a given object implements the LicenseFeatureRequest interface.
 */
export function instanceOfLicenseFeatureRequest(value: object): value is LicenseFeatureRequest {
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function LicenseFeatureRequestFromJSON(json: any): LicenseFeatureRequest {
    return LicenseFeatureRequestFromJSONTyped(json, false);
}

export function LicenseFeatureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseFeatureRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'expiresAtSeconds': json['expiresAtSeconds'] == null ? undefined : json['expiresAtSeconds'],
    };
}

export function LicenseFeatureRequestToJSON(json: any): LicenseFeatureRequest {
    return LicenseFeatureRequestToJSONTyped(json, false);
}

export function LicenseFeatureRequestToJSONTyped(value?: LicenseFeatureRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'expiresAtSeconds': value['expiresAtSeconds'],
    };
}

